import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Table, Icon, Row, Col, Popconfirm, Divider, Input, Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { Animated } from "react-animated-css";
import HeaderContent from '../common/headercontent/HeaderContent';
import AddSchoolQuotaModal from './modal/AddSchoolQuotaModal';
import moment from 'moment';

import './schoolquota.css';

import {
  schoolquotaList,
  schoolquotaDelete,
  schoolquotaUpdate,
} from '../../modules/schoolquota';

class SchoolQuota extends Component {
	constructor(props){
		super(props);
		this.state = {
			addModal: false,
			selectedSchoolQuota: null,
      loading: false,
      searchText: '',
      searchedColumn: '',
		}
	}

	componentDidMount() {
		this.getSchoolQuota();		
	}

	toggleAddModal = () => {
    const { addModal } = this.state;
    if (addModal) {
      this.setState({selectedSchoolQuota: null});
    }
		this.setState({ addModal: !addModal });
	}

	onSelectSchoolQuota(schoolquotaId = null) {
		window.scrollTo(0, 0);
		this.setState({ selectedSchoolQuota: null });
		setImmediate(()=> {
			this.setState({ selectedSchoolQuota: schoolquotaId });
		});
	}

	getSchoolQuota() {
    this.setState({ loading: true });
		this.props.schoolquotaList().then(
      () => {
        this.setState({ loading: false });
      },
      () => {
        this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` });
      }
    );		
	}


	onDeleteConfirm(schoolquotaId) {
		const { selectedSchoolQuota } = this.state;

		this.props.schoolquotaDelete(schoolquotaId).then( 
			(res) => {
				if (schoolquotaId === selectedSchoolQuota) {
					this.setState({ selectedSchoolQuota: null });
				}
				this.getSchoolQuota();
			},
			(err) => {
				this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` }); 
			}
		);
	}

  onInactiveConfirm(schoolquotaId) {
		const { selectedSchoolQuota } = this.state;

		this.props.schoolquotaUpdate({status: 'inactive'}, schoolquotaId).then( 
			(res) => {
				if (schoolquotaId === selectedSchoolQuota) {
					this.setState({ selectedSchoolQuota: null });
				}
				this.getSchoolQuota();
			},
			(err) => {
				this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` }); 
			}
		);
	}
  
  onEditSchoolQuota = (selected) => {
    this.setState({selectedSchoolQuota: selected});
    this.toggleAddModal();
  }

  getColumnSearchProps = (dataIndex, displayName) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`搜尋${displayName}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          搜尋
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          重設
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

	render() {
      
		const { addModal, selectedSchoolQuota, loading } = this.state;

		const columns = [{
			title: '學校(中文)',
			dataIndex: 'name_tc',
			key: 'name_tc',
      ...this.getColumnSearchProps('name_tc', '學校(中文)'),
    }, {
			title: '年度',
			dataIndex: 'year',
			key: 'year',
      ...this.getColumnSearchProps('year', '年度'),
		}, {
			title: '已產生',
			dataIndex: 'generated',
			key: 'generated',
    }, {
			title: '限額',
			dataIndex: 'quota',
			key: 'quota',
		}, {
			title: '操作',
			key: 'action',
			render: (text, data) => (
      (this.props.userProfile.user && this.props.userProfile.user.role === 'admin') ?
        <span>
          <a onClick={() => this.onEditSchoolQuota(data)}>編輯</a>
          <Divider type="vertical" />
          <Popconfirm title="刪除學校?" onConfirm={() => this.onInactiveConfirm(data._id)} okText="是" cancelText="否"><a>刪除</a></Popconfirm>
        </span>
      : "-"
		),
		}
	];

		const headerData = {
			button: {
				title: <span><Icon type="file-add" /> 新增學校限額</span>,
				function: () => this.toggleAddModal()
			}
		};
		
		const headerSSchoolQuotaData = (selectedSchoolQuota) ? {
			close: {
				title: <Icon type="close-square" />,
				function: () => this.onSelectSchoolQuota()
			}
		} : "";

		let data = [];
		let sSchoolQuota = [];
		if (this.props.schoolQuotaData) {
			data = this.props.schoolQuotaData.results.map(schoolquota => {
        const groups = schoolquota.groups;
        let generated = 0;
        if (groups) {
          if (Array.isArray(groups.students)) {
            generated = groups.students.length;
          } else if (Array.isArray(groups)) {
            generated = groups.reduce((sum, group) => sum + (group.studentCount || 0), 0);
          } else {
            generated = groups.studentCount || 0;
          }
        }
				return {
					_id: schoolquota._id,
          schoolId: schoolquota.schoolId,
          name_tc: schoolquota.school.name_tc,
          year: schoolquota.year,
          generated,
          quota: schoolquota.quota,
				}
			});

      if (this.props.userProfile.user && this.props.userProfile.user.role !== 'admin') {
        data = data.filter(d => d.schoolId === this.props.userProfile.user.schoolId);
      }

			sSchoolQuota = this.props.schoolQuotaData.results.filter(school=>school._id === selectedSchoolQuota);
    }

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
					<Col>	
							<HeaderContent title="學校年度問卷配額" subtitle="學校年度問卷配額" data={this.props.userProfile.user && this.props.userProfile.user.role === 'admin' ? headerData : ''} />
							<Card title={<p><span>學校年度 </span></p>}>
								<Table columns={columns} dataSource={data} loading={loading} />
							</Card>

							<AddSchoolQuotaModal 
								show={addModal} 
                toggleAddModal={this.toggleAddModal.bind(this)} 
                selected={selectedSchoolQuota}
							/>
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	schoolQuotaData: state.schoolquota.data,
  userProfile: state.user.userProfile,
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		schoolquotaList,
		schoolquotaDelete,
    schoolquotaUpdate,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(SchoolQuota);
